(function () {
  var variants = window.nnProductVariants || [];

  var form         = document.getElementById('customProductForm');
  var mainImgWrap  = document.getElementById('mainProductImage');
  var mainImg      = mainImgWrap ? mainImgWrap.querySelector('img') : null;
  var variantInput = form ? form.querySelector('input[name="id"]') : null;
  var priceEl      = document.getElementById('productPrice');
  var btnPriceEl   = document.getElementById('btnPrice');

  if (!form) return;

  function getSelectedOptions() {
    var opts = [];
    form.querySelectorAll('.product-option').forEach(function (optionWrap) {
      var checked = optionWrap.querySelector('input[type="radio"]:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(selectedOpts) {
    return variants.find(function (v) {
      var vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
      return selectedOpts.every(function (val, i) { return vOpts[i] === val; });
    });
  }

  function updateImage(variant) {
    if (!mainImg || !variant || !variant.featured_image) return;
    var src = variant.featured_image.src;
    src = src.replace(/(\.[^.?]+)(\?.*)?$/, '_800x800$1$2');
    mainImg.src = src;
    if (variant.featured_image.alt) mainImg.alt = variant.featured_image.alt;
  }

  function updatePrice(variant) {
    if (!variant) return;
    var price = (variant.price / 100).toFixed(2);
    var symbol = 'A$';
    var formatted = symbol + price;
    if (priceEl) {
      var cur = priceEl.querySelector('.price-current');
      var cmp = priceEl.querySelector('.price-compare');
      if (cur) cur.textContent = formatted;
      if (cmp) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          cmp.textContent = symbol + (variant.compare_at_price / 100).toFixed(2);
          cmp.style.display = '';
        } else {
          cmp.style.display = 'none';
        }
      }
    }
    if (btnPriceEl) btnPriceEl.textContent = formatted;
  }

  function updateVariantId(variant) {
    if (variantInput && variant) variantInput.value = variant.id;
  }

  function onOptionChange() {
    var selected = getSelectedOptions();
    var variant  = findVariant(selected);
    if (!variant) return;
    updateImage(variant);
    updatePrice(variant);
    updateVariantId(variant);
  }

  form.querySelectorAll('input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', onOptionChange);
  });

  // ── Thumbnail clicks ─────────────────────────────────────────────────────
  document.querySelectorAll('.thumbnail').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      document.querySelectorAll('.thumbnail').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      mainImg.src = btn.getAttribute('data-image-url');
    });
  });

  // ── Accordion ────────────────────────────────────────────────────────────
  document.querySelectorAll('.accordion-header').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item    = btn.closest('.accordion-item');
      var content = item.querySelector('.accordion-content');
      var icon    = btn.querySelector('.accordion-icon');
      var isOpen  = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.accordion-item').forEach(function (el) {
        el.classList.remove('open');
        el.querySelector('.accordion-content').style.maxHeight = null;
        var ic = el.querySelector('.accordion-icon');
        if (ic) ic.textContent = '+';
      });

      // Open clicked one if it was closed
      if (!isOpen) {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
        if (icon) icon.textContent = '×';
      }
    });
  });

})();
